module["exports"] = [
  "#",
  "##",
  "###"
];
